export enum SEVERITY {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

export type NotificationT = {
  open: boolean;
  message: string;
  severity: SEVERITY;
};
